import { Form, Input, Select } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { H6 } from "../../../../AbstractElements";
import { TermsAndCondtitionsAPI } from "../../../../api";

const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});

const TermsAndConditions = (props) => {
  const { defaultTC, defaultTCDesc } = props;
  const { Option } = Select;
  const [terms, setTerms] = useState([]);
  useEffect(() => {
    fetchTerms();
  }, []);
  const fetchTerms = () => {
    axios
      .get(
        `${TermsAndCondtitionsAPI}` +
          "?organisation_id=" +
          props.settings?.user?.organisation?.organisation_id
      )
      .then((res) => {
        setTerms(res.data);
      });
  };
  useEffect(() => {
    console.log("defaultTC", defaultTC, defaultTCDesc);
    if (terms.length > 0 && !defaultTC) {
      props.handleTermsandConditions({
        id: terms[0]?.id,
        terms_and_conditions_description: terms[0]?.description,
      });
    }
  }, [defaultTC, defaultTCDesc, terms]);

  const termsOptions = terms?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each?.title}
    </Option>
  ));

  return (
    <React.Fragment>
      <div className="">
        <H6>Terms and Conditions</H6>
        <Form.Item>
          <Select
            className="w-100"
            key={defaultTC}
            value={
              defaultTC == "" && terms?.length > 0 ? terms[0]?.id : defaultTC
            }
            onChange={(e) => {
              const termSelected = terms?.find((term) => term?.id == e);
              props.handleTermsandConditions({
                id: e,
                terms_and_conditions_description: termSelected?.description,
              });
            }}
          >
            {termsOptions}
          </Select>
          <div className="mt-2">
            <Input.TextArea
              autoSize={{
                minRows: 4,
                maxRows: 20,
              }}
              key="description_terms"
              placeholder="Add Terms and Conditions here"
              value={defaultTCDesc}
              onChange={(e) => {
                props.handleTermsandConditionsDesc(e.target.value);
              }}
            />
          </div>
        </Form.Item>
      </div>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(TermsAndConditions);
